var hacker = {};
module['exports'] = hacker;
hacker.adjective = require("./adjective");
hacker.noun = require("./noun");
hacker.verb = require("./verb");
hacker.phrase = require("./phrase");
